import Dexie    from "dexie";

// const log = global.log.getLogger("f_mtac.global.test");

let Test = function(global) {
    this.set_background_image = (file) => {
        return global.scene.background_image.select({file});
    };
    
    this.delete_databases = async () => {
        const databases = await Dexie.getDatabaseNames();
        for (let db_name of databases) {
            let database = new Dexie(db_name, {autoOpen: false});
            await database.delete();
        }
        let dbnames = new Dexie("__dbnames", {autoOpen: false});
        await dbnames.delete();
    };
    
};

export default Test;